import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

import useEvaluation from '../contexts/Evaluation';
import useApplication from '../contexts/Application';
import Application from './Application';


const Box = styled.div`
  ul {
    list-style-type: none;
    padding: 0;
    margin: 2rem 0 0 0;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: ${props => props.theme.colors.dirty};
      border: 1px solid ${props => props.theme.colors.gray};
      border-radius: 4px;
      padding: 10px;
      margin: 0;

      h2 {
        margin: 0;
        padding: 0;
      }

      .completed {
        display: block;
        color: ${props => props.theme.colors.green};
        font-weight: 600;
        font-size: 1.4rem;
        height: 3.6rem;
        line-height: 3.6rem;
        letter-spacing: -.024rem;
      }

      + li {
        margin-top: 2rem;
      }
    }
  }
`;


const Evaluation = () => {
  const { applications } = useEvaluation();
  const { application, setApplication } = useApplication();
  const theme = useContext(ThemeContext);

  return (
    <>
      {applications && !application && (
        <Box theme={theme}>
          <h1>Assessments</h1>
          <ul>
            {applications.map(item => {
              return (
                <li key={item.eid}>
                  <h2>{item.assessment.title}</h2>
                  {!item.started && !item.corrected && (<button onClick={() => setApplication(item)} className="primary">Start Assessment</button>)}
                  {item.started && !item.corrected && (<button onClick={() => setApplication(item)} className="primary">Continue Assessment</button>)}
                  {item.corrected && (<span className="completed">Assessment Completed</span>)}
                </li>
              )
            })}
          </ul>
        </Box>
      )}
      <Application />
    </>
  );
};

export default Evaluation;
